var Buf = require('buf');
var ChannelList = require('channellist');
var ConversationList = require('conversationlist');


var ConnectionBufferList = Backbone.Collection.extend({
    model: Buf,
    initialize: function (models, options) {
        this.connection = options.connection;
        
        this._lookup = {};
        this._reverseLookup = {};
        this.channels      = new ChannelList;
        this.conversations = new ConversationList;
        
        this.pinnedBuffers         = this.connection.session.pinnedBuffers;
        this.activeChannels        = new ChannelList;
        this.inactiveChannels      = new ChannelList;
        this.archivedChannels      = new ChannelList;
        this.activeConversations   = new ConversationList;
        this.archivedConversations = new ConversationList;
        
        this.bind('add', this.addBuffer, this);
        this.bind('remove', this.removeBuffer, this);
        this.bind('change:archived', this.moveBuffer, this);
        this.bind('change:name', this.moveBuffer, this);
        this.bind('beforePinnedChange', this.beforePinnedChange, this);
        this.bind('pinnedChange', this.pinnedChange, this);
        this.bind('resetLookup', this.resetLookup, this);
        this.bind('twitchChannelChange', this.moveBuffer, this);
        this.bind('activeChange', function (buffer) {
            // Conversations don't move based on being active
            if (!this.isConversation(buffer)) {
                this.moveBuffer(buffer);
            }
        }, this);
        this.listenTo(this.connection, 'init', this.sortBuffers);
        this.listenTo(this.connection, 'archivesFetched', this.sortBuffers);
    },
    lookup: function (name, exact) {
        if (name) {
            if (exact) {
                return this.findWhere({name: name});
            } else {
                return this._lookup[name.toLowerCase()];
            }
        }
    },
    shouldSortBuffers: function () {
        return this.connection.isInitialized() && !this.connection.isFetchingArchives();
    },
    sortBuffers: function () {
        _.each([
            this.channels,
            this.conversations,
            this.activeChannels,
            this.inactiveChannels,
            this.archivedChannels,
            this.activeConversations,
            this.archivedConversations
        ], function (list) {
            list.sort();
        });
    },
    getOrder: function (important) {
        var order = [this.activeChannels];
        if (!important) {
            order.push(this.inactiveChannels);
            order.push(this.activeConversations);
        } else if (this.connection.isActive()) {
            order.push(this.activeConversations);
        }
        if (!important) {
            order.push(this.archivedChannels);
            order.push(this.archivedConversations);
        }
        return order;
    },
    getFirstBuffer: function (important) {
        var orders = this.getOrder(important);
        var result;
        for (var i = 0; i < orders.length; i++) {
            result = orders[i].first();
            if (result) {
                return result;
            }
        }
    },
    getLastBuffer: function (important) {
        var orders = this.getOrder(important);
        var result;
        for (var i = orders.length - 1; i > -1; i--) {
            result = orders[i].last();
            if (result) {
                return result;
            }
        }
        if (!important) {
            return this.connection.serverLog;
        }
    },
    hasSpam: function () {
        var potentialSpam = this.activeConversations.reduce(function (acc, c) {
            if (c.hasUnseen() && c.messages.length && c.messages.last().id === c.get('created')) {
                return ++acc;
            } else {
                return acc;
            }
        }, 0, this);
        return potentialSpam > 3;
    },
    hasChildren: function () {
        return !!(this.channels.length || this.conversations.length);
    },
    hasArchivedBuffers: function () {
        return this.connection.hasDeferredArchives() || !!(this.archivedChannels.length || this.archivedConversations.length);
    },
    hasActiveConversations: function () {
        return !!(this.activeConversations.length);
    },
    findSegment: function (buffer) {
        return _.detect([
            this.activeChannels,
            this.inactiveChannels,
            this.archivedChannels,
            this.activeConversations,
            this.archivedConversations
        ], function (list) {
            return !!list.get(buffer.bid());
        });
    },
    isChannel: function (buffer) {
        return buffer.isChannel() && !buffer.isSlackMultiPersonDm();
    },
    isConversation: function (buffer) {
        if (buffer.isChannel() && buffer.isSlackMultiPersonDm()) {
            return true;
        }
        return buffer.isConversation();
    },
    getBufferList: function (buffer) {
        if (this.isChannel(buffer)) {
            return this.channels;
        } else if (this.isConversation(buffer)) {
            return this.conversations;
        }
    },
    getSegmentedBufferList: function (buffer) {
        if (buffer.isPinned()) {
            return this.pinnedBuffers;
        }
        if (this.isChannel(buffer)) {
            if (buffer.isArchived()) {
                return this.archivedChannels;
            } else if (buffer.isActive()) {
                return this.activeChannels;
            } else {
                return this.inactiveChannels;
            }
        } else if (this.isConversation(buffer)) {
            if (buffer.isArchived()) {
                return this.archivedConversations;
            } else {
                return this.activeConversations;
            }
        }
    },
    addBuffer: function (buffer) {
        this.addLookup(buffer);
        var bufferList = this.getBufferList(buffer);
        if (bufferList) {
            bufferList.add(buffer, {
                sort: this.shouldSortBuffers()
            });
            this.addSegmentedBuffer(buffer);
        }
    },
    resetLookup: function (buffer) {
        var name = buffer.getName().toLowerCase();
        var displayName = buffer.getDisplayName().toLowerCase();
        _.each(this._reverseLookup[buffer.bid()], function (key) {
            if (key !== name && key !== displayName) {
                var otherBuffer = this.findWhere({name: key});
                if (otherBuffer) {
                    this.addLookup(otherBuffer);
                } else {
                    delete this._lookup[key];
                }
            } else {
                delete this._lookup[key];
            }
        }, this);
        delete this._reverseLookup[buffer.bid()];
        this.addLookup(buffer);
    },
    addLookup: function (buffer) {
        var name = buffer.getName().toLowerCase();
        
        if (!this._reverseLookup[buffer.bid()]) {
            this._reverseLookup[buffer.bid()] = [];
        }
        this._reverseLookup[buffer.bid()].push(name);
        this._lookup[name] = buffer;
        if (buffer.isActive()) {
            var displayName = buffer.getDisplayName().toLowerCase();
            if (displayName != name) {
                // Remove any existing reverse lookups for this display name
                if (this._lookup[displayName]) {
                    var existingId = this._lookup[displayName].id;
                    this._reverseLookup[existingId] = _.without(
                        this._reverseLookup[existingId], displayName
                    );
                }
                this._lookup[displayName] = buffer;
                this._reverseLookup[buffer.bid()].push(displayName);
                
            }
        }
        this._reverseLookup[buffer.bid()] = _.unique(this._reverseLookup[buffer.bid()]);
    },
    removeLookup: function (buffer) {
        _.each(this._reverseLookup[buffer.bid()], function (key) {
            delete this._lookup[key];
        }, this);
        delete this._reverseLookup[buffer.bid()];
    },
    removeBuffer: function (buffer) {
        this.removeLookup(buffer);
        this.getBufferList(buffer).remove(buffer);
        this.removeSegmentedBuffer(buffer);
    },
    addSegmentedBuffer: function (buffer) {
        var segment = this.getSegmentedBufferList(buffer);
        if (segment) {
            segment.add(buffer, {
                sort: this.shouldSortBuffers()
            });
        }
    },
    removeSegmentedBuffer: function (buffer) {
        var segment = this.getSegmentedBufferList(buffer);
        if (segment) {
            segment.remove(buffer);
        }
    },
    beforePinnedChange: function (buffer) {
        // For buffers about to be pinned, remove from existing segment
        if (!buffer.isPinned()) {
            var segment = this.findSegment(buffer);
            if (segment) {
                segment.remove(buffer, {silent: true});
            }
        }
        // Trigger event to remove from existing sidebar
        buffer.trigger('moveSegment');
    },
    pinnedChange: function (buffer) {
        // For freshly unpinned buffers, add it to a new segment
        if (!buffer.isPinned()) {
            this.addSegmentedBuffer(buffer);
        }
    },
    moveBuffer: function (buffer) {
        this.addLookup(buffer);
        // We don't want to trigger a remove event on the
        // buffer or everything will get removed from the DOM.
        var segment = this.findSegment(buffer);
        if (segment) {
            segment.remove(buffer, {silent: true});
            buffer.trigger('moveSegment');
        }
        this.addSegmentedBuffer(buffer);
    }
});


module.exports = ConnectionBufferList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/connectionbufferlist.js
// module id = h0MN
// module chunks = 1